import gsap from 'gsap/dist/gsap.min'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.min'
import { CustomEase } from 'gsap/dist/CustomEase.min'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin.min'
import Swiper from 'swiper/bundle'
import UAParser from 'ua-parser-js'
import SmoothScroll from 'ui/SmoothScroll'
import Loader from 'ui/Loader'
import FillHeight from 'ui/FillHeight'
import Accordion from 'ui/Accordion'
import Slider from 'ui/Slider'
import YtPlayer from 'ui/YtPlayer'
import HoverVideo from 'ui/HoverVideo'
import Menu from 'pages/Sunsunkidstv/Menu';
import Popup from 'pages/Sunsunkidstv/Popup'

import ScrollAnimation from 'pages/Sunsunkidstv/ScrollAnimation';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.ScrollToPlugin = ScrollToPlugin
window.CustomEase = CustomEase
window.Swiper = Swiper

const parser = new UAParser()
const model = parser.getDevice().model
if (model === 'iPad') {
  document
    .querySelector('meta[name=viewport]')
    .setAttribute('content', 'width=375')
  document.documentElement.classList.add(`is-iPad`)
}

window.addEventListener('DOMContentLoaded', () => {
  Promise.all([new Loader()]).then(() => {
    new Menu();
    new SmoothScroll()
    new FillHeight()
    new Accordion()
    new Slider()
    new YtPlayer()
    new HoverVideo()
    // new Popup()
    new ScrollAnimation();
  });
})
